import React from 'react';
import Breadcrumbs from 'src/Lca/components/Breadcrumbs';
import { Subtitle, Title } from 'src/Lca/components/Texts';
import LcaLayout from 'src/Lca/components/layout';
import { Box, Button, Tab, Tabs, Typography } from '@mui/material';
import ProductInformation from '../steps/productInformation';
import { emptyProductForm, sanitizedValues } from '../utils';
import { StyledFlex } from 'src/components/StyledFlex';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { client } from 'src/utils/api-client';
import { toast } from 'react-toastify';
import { useLcaOrganization } from 'src/common/hooks';
import { StyledPanel } from 'src/Lca/styles';
import { useTranslation } from 'react-i18next';
import IntroductionsGrid from 'src/Lca/components/IntroductionsGrid';

export default function CreateLcaProductInformation() {
  const { t } = useTranslation('lca');
  const navigate = useNavigate();
  const organization = useLcaOrganization();
  const [productForm, setProductFrom] = React.useState(emptyProductForm);

  const data = [
    { name: t('productList'), url: '/lca/products' },
    { name: t('newProduct'), url: '' },
    { name: t('productStep1'), url: '' },
  ];

  const createProduct = useMutation({
    mutationFn: () =>
      client
        .post('/web/lca/products', sanitizedValues(productForm, organization))
        .then((res) => {
          navigate(`/lca/products/${res.data.id}`, { replace: true });
          toast.success(t('product.createdSuccessfully') as string);
        }),
    onError: (e: any) => {
      toast.error(e.response.data.message);
    },
  });

  return (
    <LcaLayout>
      <Breadcrumbs data={data} />
      <Subtitle text={t('product.productAndLcaInformation')} />
      <div style={{ marginTop: '44px', marginBottom: '40px' }}>
        <Title text={t('product.newProduct')} />
      </div>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            lg: 'minmax(0, 1.8fr) minmax(360px, 1fr)',
          },
          gap: '24px',
          alignItems: 'start',
          pb: '80px',
        }}
      >
        <Box>
          <Tabs value="prod-information">
            <Tab
              key="prod-information"
              label={t('product.productInformation')}
              value="prod-information"
            />
          </Tabs>

          <StyledPanel>
            <ProductInformation
              values={productForm}
              setValues={setProductFrom}
              basicInfoOnly
            />
          </StyledPanel>

          <StyledFlex sx={{ mt: '40px' }}>
            <Button
              variant="secondary"
              onClick={() => navigate(-1)}
              type="button"
            >
              {t('product.back')}
            </Button>
            <Button
              variant="secondary"
              onClick={() => createProduct.mutate()}
              disabled={!productForm.name || !productForm.description}
            >
              {t('product.saveAndContinue')}
            </Button>
          </StyledFlex>
        </Box>

        <StyledPanel
          sx={{
            mt: 0,
            p: '24px',
            position: { lg: 'sticky' },
            top: { lg: '20px' },
          }}
        >
          <Typography variant="h4" sx={{ mb: '16px' }}>
            {t('introduction')}
          </Typography>
          <Typography variant="body1" sx={{ color: '#4d4d4d', mb: '12px' }}>
            {t('introductionSidebarSentenceOne')}
          </Typography>
          <Typography variant="body1" sx={{ color: '#4d4d4d', mb: '20px' }}>
            {t('introductionSidebarSentenceTwo')}
          </Typography>

          <IntroductionsGrid variant="sidebar" />
        </StyledPanel>
      </Box>
    </LcaLayout>
  );
}
